$(function() {
    $('.btn-toggle-menu').click(function(e) {
        
        e.preventDefault();

        $(this).toggleClass('active');
        
        $('.toggle-menu').slideToggle();
    });
});
